/**
 * Converts a string into a `Uint16Array`.
 */

const stringToUint16Array = (input: string): Uint16Array =>
    new Uint16Array(input.split('').map(c => c.charCodeAt(0)));

export default stringToUint16Array;